import styled from 'styled-components';

import { grey1 } from 'approot/shared/styles/colours.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const ActivityBuilderPrintPictureStatic = styled.picture`
  img {
    width: 100%;
  }
`;

export const ActivityBuilderPrintSlideshowImage = styled.div`
  ${flexCentreAlignCss}
  height: 100%;

  img {
    background-color: ${grey1};
  }
`;
